/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientDispenseRecordImageTypename = "PatientDispenseRecordImage" as const;

/**
 *
 * @export
 * @interface PatientDispenseRecordImage
 */
export interface PatientDispenseRecordImage {
  /**
   *
   * @type {boolean}
   * @memberof PatientDispenseRecordImage
   */
  hidden?: boolean;
  /**
   *
   * @type {number}
   * @memberof PatientDispenseRecordImage
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof PatientDispenseRecordImage
   */
  path?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientDispenseRecordImage
   */
  readonly __typename?: string;
}

export function PatientDispenseRecordImageFromJSON(json: any): PatientDispenseRecordImage {
  return PatientDispenseRecordImageFromJSONTyped(json, false);
}

export function PatientDispenseRecordImageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatientDispenseRecordImage {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientDispenseRecordImageTypename,

    hidden: !exists(json, "hidden") ? undefined : json["hidden"],
    id: !exists(json, "id") ? undefined : json["id"],
    path: !exists(json, "path") ? undefined : json["path"],
  };
}

export function PatientDispenseRecordImageToJSON(object?: PatientDispenseRecordImage | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    hidden: value.hidden,
    id: value.id,
    path: value.path,
  };
}
